module.exports = __webpack_public_path__ + "static/img/PC-8.1bd90e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgzgk/PC-8.png
// module id = MUEX
// module chunks = 0